import {
	SearchIntegrationKind,
	GlobalSearchScopeKind,
	ScopeSearchNodeModel
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import {
	FunctionComponent,
	ReactElement,
	useMemo
} from "react";
import { AppSearch } from "./SearchResults/AppSearch";
import { FileSearch } from "./SearchResults/FileSearch";
import { EmailSearch } from "./SearchResults/EmailSearch";
import { ContactSearch } from "./SearchResults/ContactSearch";
import { FolderSearch } from "./SearchResults/FolderSearch";
import { AnnouncementSearch } from "./SearchResults/AnnouncementSearch";
import { KnowledgeItemSearch } from "./SearchResults/KnowledgeItemSearch";
import { EgnyteSearch } from "./SearchResults/EgnyteSearch";
import { EventSearch } from "./SearchResults/EventSearch";
import { createIntegrationFlowSearch } from "./SearchResults/IntegrationFlowSearch";
import { CommunitySearch } from "./SearchResults/CommunitySearch";
import { CommunityPostSearch } from "./SearchResults/CommunityPostSearch";

export type ScopeViewProps = {
	searchTerm: VersionedValue<string>;
	scope: ScopeSearchNodeModel;
	mobileSearchSettingsElement: HTMLDivElement | null;
};

export const ScopeView = (props: ScopeViewProps): ReactElement => {
	const {
		searchTerm,
		scope,
		mobileSearchSettingsElement
	} = props;

	const Component = useMemo(
		(): SearchScopeImplementation => scope.scopeKind === GlobalSearchScopeKind.Predefined
			? scopeToImplementationMapMap[scope.predefinedKind]
			: createIntegrationFlowSearch(
				scope.integrationId,
				scope.name
			),
		[scope]
	);

	return (
		<Component
			mobileSearchSettingsTarget={mobileSearchSettingsElement}
			searchTerm={searchTerm}
		/>
	);
};
ScopeView.displayName = "ScopeView";

type SearchScopeImplementation = FunctionComponent<{
	searchTerm: VersionedValue<string>;
	mobileSearchSettingsTarget: HTMLDivElement | null;
}>;

const scopeToImplementationMapMap: Record<SearchIntegrationKind, SearchScopeImplementation> = {
	[SearchIntegrationKind.Apps]: AppSearch,
	[SearchIntegrationKind.Files]: FileSearch,
	[SearchIntegrationKind.Emails]: EmailSearch,
	[SearchIntegrationKind.Contacts]: ContactSearch,
	[SearchIntegrationKind.Folders]: FolderSearch,
	[SearchIntegrationKind.Announcements]: AnnouncementSearch,
	[SearchIntegrationKind.KnowledgeItems]: KnowledgeItemSearch,
	[SearchIntegrationKind.Egnyte]: EgnyteSearch,
	[SearchIntegrationKind.Events]: EventSearch,
	[SearchIntegrationKind.Communities]: CommunitySearch,
	[SearchIntegrationKind.CommunityPosts]: CommunityPostSearch
};